// extracted by mini-css-extract-plugin
export default {"component":"feelingsMeter__component___DSKc8","face":"feelingsMeter__face___XlQd-","number":"feelingsMeter__number___ned3r","feelings":"feelingsMeter__feelings___r06yM"};